import { Client, Databases, Storage, Functions, Account, Teams, ID, Permission, Role, Query, Avatars } from 'appwrite'

const client = new Client()
    .setEndpoint(process.env.REACT_APP_ENDPOINT)
    .setProject(process.env.REACT_APP_PROJECT_ID)
    // .setDevKey(process.env.REACT_APP_DEV_KEY)

const databases = new Databases(client)
const storage = new Storage(client)
const functions = new Functions(client)
const account = new Account(client)
const teams = new Teams(client)
const avatars = new Avatars(client)

export { client, databases, storage, functions, account, teams, avatars, ID, Permission, Role, Query }